<script setup lang="ts">
import { computed } from 'vue'
import { numHelper } from '@/utils/numHelper.ts'

interface Props {
  data: object | string | number,
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const data = computed(() => props.data as object)
</script>

<template>
  <div class="flex flex-col">
    <div class="flex gap-[7px]">
      <div class="w-[100px] text-right whitespace-nowrap">Tổng chào giá:</div>
      <div class="font-bold">{{ data.total }}</div>
    </div>
    <div class="flex gap-[7px]">
      <div class="w-[100px] text-right whitespace-nowrap">Giá cao nhất:</div>
      <div class="font-bold">{{ numHelper(data.max_price).format() }} <sup>đ</sup></div>
    </div>
    <div class="flex gap-[7px]">
      <div class="w-[100px] text-right whitespace-nowrap">Giá thấp nhất:</div>
      <div class="font-bold">{{ numHelper(data.min_price).format() }} <sup>đ</sup></div>
    </div>
    <div class="flex gap-[7px]">
      <div class="w-[100px] text-right whitespace-nowrap">Phí đặt cọc:</div>
      <div class="font-bold">{{ numHelper(data.deposit_price).format() }} <sup>đ</sup></div>
    </div>
  </div>
</template>

<style scoped>

</style>
